import gql from 'graphql-tag'
import {
    UpdatePresentationSpaceInput,
    UpdatePresentationSpaceMutation as UpdateMutation,
    UpdatePresentationSpaceMutationVariables as UpdateVariables
} from 'generated/graphql'
import graphql from 'utils/graphql'

// Update Presentation Space
const updatePresentationSpaceMutation = gql`
    mutation updatePresentationSpace ($data: UpdatePresentationSpaceInput!, $id: Int!) {
        updatePresentationSpace(data: $data, id: $id) {
            id
            parent {
                image
            }
        }
    }
`

export const updatePresentationSpace = (id: number, data: UpdatePresentationSpaceInput) => {
    const query = graphql.createQuery<UpdateMutation, UpdateVariables>(updatePresentationSpaceMutation)
    return query({ id, data })
}
